import React from "react";

export type TAccordionPaneContext = {
  setCount: (v: number) => void;
};

export const AccordionRowContext = React.createContext<
  Partial<TAccordionPaneContext>
>({});
